<template>
	<TopStatistic :title="title" type="brand" />
</template>
<script>
	import TopStatistic from '@/components/operation/ReviewStatistic/TopStatistic.vue';
	export default {
		components: {
			TopStatistic,
		},
		data() {
			return {
				title: ['랭킹', '브랜드명', '리뷰수'],
			};
		},
	};
</script>
<style lang="scss" scoped></style>
